export const NOT_AVAILABLE = 'N/A';

// CaptionType values as transformed by the saga (parseEnumType converts numeric
// enum indices to their string keys from transactionCaptionTypes).
export const FIELD_CAPTION_TYPE = {
  ORDER_TOTAL: 'OrderTotal',
  PRICE_PER_UNIT: 'PricePerUnit',
  REFERENCE_NUMBER: 'ReferenceNumber',
  SUBMITTER: 'Submitter',
  SUMMARY: 'Summary',
  CREDIT_CARD: 'CreditCardLastFourDigits',
  SHIPPING_FEE: 'ShippingFee',
  INSURANCE_FEE: 'ShippingInsuranceFee',
  PRE_AUTH_AMOUNT: 'CreditCardAuthorizedAmount',
};

export const getTransactionField = (fields, captionType) =>
  (fields ?? []).find((f) => f.CaptionType === captionType) ?? null;

export const CANCELLED_STEP_KEY = 'cancelled';

export const isCancelledStatus = (value) => /cancel/i.test(value ?? '');

export function buildTimelineSteps(history) {
  if (!Array.isArray(history)) return [];
  return history
    .filter((step) => !(isCancelledStatus(step.Key) && !step.DateTime))
    .map((step) => {
      const cancelled = isCancelledStatus(step.Key);
      let status = 'pending';
      if (cancelled) status = 'cancelled';
      else if (step.DateTime) status = 'completed';
      return {
        key: cancelled ? CANCELLED_STEP_KEY : step.Key,
        status,
        dateTime: step.DateTime,
        cancellable: Boolean(step.Cancellable),
      };
    });
}
